import React from 'react';
import styles from './modal-header.module.css';

interface ModalHeaderProps {
    children: React.ReactNode;
    onClose: () => void;
    showClose?: boolean;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({
    children,
    onClose,
    showClose = true,
}) => {
    return (
        <div className={styles.header}>
            <div className="heading-title-new">{children}</div>

            {showClose && (
                <button
                    type="button"
                    onClick={onClose}
                    className={styles.close}
                >
                    ✕
                </button>
            )}
        </div>
    );
};

export default ModalHeader;